var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"ma-1 pa-3 rounded-xl mb-3"},[_c('v-card-title',{staticClass:"headline primary--text"},[_vm._v("Gestão de ocorrências")]),_c('v-card-text',[_c('ocorrencia-component')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }